var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12 col-md-10 image"},[(_vm.image)?_c('img',{attrs:{"src":_vm.image.url,"alt":_vm.image.title}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }